import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {TracciatiService} from '../../../_services/tracciato.service';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {SearchResult, Tracciato} from '../../../_models/_Index';
import {SaveMessage} from '../../../_helpers/save-message';

@Component({
  selector: 'app-select-tracciati',
  templateUrl: './select-tracciati.component.html',
  styleUrls: ['./select-tracciati.component.scss'],
  standalone: false
})
export class SelectTracciatiComponent implements OnInit {
  @Input() tracciatoId: number;
  @Input() sorgente?: number;
  @Input() sorgentiEscluse: readonly number[] = [];
  @Output() tracciatoIdChange = new EventEmitter<number>();
  @Output() tracciatoChange = new EventEmitter<Tracciato | undefined>();
  loading = false;
  private allTracciati: Tracciato[] = [];

  constructor(
    private saveMessage: SaveMessage,
    private tracciatiService: TracciatiService,
    private organizzazioniService: OrganizzazioniService) { }

  get tracciati(): Tracciato[] {
    return this.allTracciati.filter((tracciato) =>
      (this.sorgente == null || tracciato.sorgenteTracciato === this.sorgente) &&
      !this.sorgentiEscluse.includes(tracciato.sorgenteTracciato)
    );
  }

  ngOnInit() {
    this.getTracciati();
  }

  getTracciati = () => {
    this.loading = true;
    this.tracciatiService
      .getTracciatiFilteredAsync(this.organizzazioniService.organizzazioneId, '', 0, 0, 'codice', true)
      .then((_tracciati: SearchResult<Tracciato>) => {
        this.allTracciati = _tracciati.result ?? [];
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dei tracciati."))
      .finally(() => this.loading = false);
  };

  selectTracciato(e: SelectCustomEvent) {
    const tracciatoId = Number(e.target.value);
    this.tracciatoIdChange.emit(tracciatoId);
    this.tracciatoChange.emit(this.tracciati.find(tracciato => tracciato.id === tracciatoId));
  }
}
